import React from "react";
import { useTranslation } from "react-i18next";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import { NS, U2104ROLES } from "../../../U2104";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import type { U2104OrganizationFormExtendedHandlers } from "../../U2104OrganizationForm";

// Typage des props du composant
interface U2104OrganizationFormBtnsComponentProps {
  formStateHandlers: U2104OrganizationFormExtendedHandlers;
}

// Composant principal pour la barre d'outils du formulaire d'organisation
export const U2104OrganizationFormToolBar: React.FC<U2104OrganizationFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U2104ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewOrganization();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U2104ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyOrganization();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U2104ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteOrganization();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
